// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2wUT5","content":"Consent_content__3DzGT","footer":"Consent_footer__pz6if"};